export const STATS_LOADING = 'STATS_LOADING';
export const TOTAL_STATS_FULFILLED = 'TOTAL_STATS_FULFILLED';
export const GRAPH_STATS_FULFILLED = 'GRAPH_STATS_FULFILLED';
